// extracted by mini-css-extract-plugin
export var avatarContainer = "_81-0";
export var avatarTypingWave = "_81-i";
export var gray = "_81-f";
export var green = "_81-c";
export var icon = "_81-9";
export var image = "_81-1";
export var lg = "_81-6";
export var md = "_81-5";
export var presenceDot = "_81-b";
export var red = "_81-d";
export var sm = "_81-4";
export var status = "_81-a";
export var typingDot = "_81-h";
export var typingPill = "_81-g";
export var xl = "_81-7";
export var xs = "_81-3";
export var xxl = "_81-8";
export var xxs = "_81-2";
export var yellow = "_81-e";